module.exports = __webpack_public_path__ + "static/media/AT.014291ed.svg";